import React from 'react';
import PropTypes from 'prop-types';
import { externalRegistry } from '../../constants/parameters';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { Table, Button, Popconfirm } from 'antd';
import { TableRowActions } from '../';
import {
  translateBooleanClassificator,
  translateCountryClassificator,
} from '../../utils/translateHelpers';

const ExternalRegistryTable = ({
  dataSource,
  t,
  deleteClassifier,
  showModal,
}) => {
  const columns = [
    {
      title: t('tableGeneral.code'),
      dataIndex: externalRegistry.CODE,
    },
    {
      title: t('tableGeneral.en'),
      dataIndex: externalRegistry.ENGLISH,
    },
    {
      title: t('tableGeneral.et'),
      dataIndex: externalRegistry.ESTONIAN,
    },
    {
      title: t('tableGeneral.additional.country'),
      dataIndex: externalRegistry.COUNTRY_CODE,
      render: translateCountryClassificator,
    },
    {
      title: t('tableGeneral.additional.memberCode'),
      dataIndex: externalRegistry.MEMBER_CODE,
    },
    {
      title: t('tableGeneral.additional.active'),
      dataIndex: externalRegistry.ACTIVE,
      render: translateBooleanClassificator,
    },
    {
      title: t('tableGeneral.actions'),
      render: (value) => (
        <TableRowActions>
          <Button
            shape="circle"
            icon={<EditOutlined />}
            size="small"
            type="primary"
            onClick={() => showModal(value[externalRegistry.ID])}
          />
          <span className="ant-divider" />
          <Popconfirm
            title={t('popconfirm.title')}
            onConfirm={() => deleteClassifier(value[externalRegistry.ID])}
            okText={t('popconfirm.buttonYes')}
            cancelText={t('popconfirm.buttonNo')}
          >
            <Button
              shape="circle"
              icon={<DeleteOutlined />}
              size="small"
              type="primary"
            />
          </Popconfirm>
        </TableRowActions>
      ),
    },
  ];

  return (
    <Table
      rowKey={externalRegistry.CODE}
      dataSource={dataSource}
      columns={columns}
      pagination={false}
    />
  );
};

ExternalRegistryTable.propTypes = {
  dataSource: PropTypes.array,
  t: PropTypes.func.isRequired,
  deleteClassifier: PropTypes.func.isRequired,
  showModal: PropTypes.func.isRequired,
};

export default ExternalRegistryTable;
